<section class="content-wrapper no-print" #fullsection style="background: aliceblue;">
    <div class="media" style="height:70px;background:#3498db;margin-bottom:10px">
        <div class="media-left hidden-xs">
            <img class="media-object" style="height:65px;" src="{{settingData?.logo_path}}" alt="Logo">
        </div>
        <div class="media-body" style="color:#ffffff">
            <h4 class="media-heading" style="font-size:50px;line-height:60px">
                <marquee direction="left">{{settingData?.companyName}} - {{activeToken?.doctorName||''}}
                </marquee>
            </h4>
        </div>
        <div class="media-right hidden-xs">
            <div class="full-screen" (click)="openFullScreen(fullsection)">
                <i class="las la-compress-arrows-alt"></i>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="card-panel col-9 h-100" style="line-height: 1.23; flex-direction: row-reverse;max-height: 70vh;">
            <!-- <div class="col m4">
            <div class="card-panel center-align p-0" id="side-token-display" style="margin-bottom: 0px; height: 74vh;">
                <div
                    style="border-bottom: 1px solid rgb(221, 221, 221); height: 25%; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                    <div><span class="bolder-color"
                            style="font-size: 45px; font-weight: bold; line-height: 1.2;">R-1000</span><br><small
                            class="bolder-color" id="counter1" style="font-size: 25px; font-weight: bold;">Counter
                            1</small><br><small
                            style="font-size: 20px; color: rgb(0, 150, 136); font-weight: bold;">SERVED</small>
                    </div>
                </div>
            </div>
        </div> -->
            <div class="col m8">
                <div class="h-100 center-align mb-0 d-flex justify-content-center align-items-center">
                    <div>
                        <div class="bolder-color m-0 token_text">Token Number</div>
                        <span class="token_no text-center">{{activeToken?.token_no|| '000'}}</span>
                        <div class="status_text text-info text-center">{{activeToken?.statusName || ' '}}</div>
                        <div class="bolder-color" style="font-size: 40px; line-height: 1.4;">Please Proceed to</div>
                        <div style="font-size: 70px; color: red; line-height: 1.5;">{{activeToken?.counterName || ''}}
                        </div>
                        <!-- <div class="text-info text-center" style="font-size: 22px;font-weight: 600;; line-height: 1.5;">
                            {{activeToken?.doctorName || ''}}
                        </div> -->
                        <!---->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-0">
        <marquee>
            <span style="font-size: 38px; color: rgb(17, 17, 17);">Notice or Advertisement <span></span></span>
        </marquee>
    </div>
    <audio id="called_sound">
        <source src="https://jltoken.justlabtech.com/app-assets/audio/sound.mp3" type="audio/mpeg">
    </audio>
</section>